// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WoG7","rootNoMargin":"styles_rootNoMargin__3T0pd"};